/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import { theme } from "styles/theme";

const HeaderContainer = styled.div`
    display: flex;
    padding: 14px 24px;
    gap: 10px;
    align-items: center;
    border-bottom: 1px solid ${theme.neutral100};
`;

const HeaderItem = styled.p<{ width: number }>`
    color: ${theme.neutral400};
    font-size: 14px;
    font-weight: 500;
    width: ${(props) => props.width + "px"};
`;
export const Header = () => {
    return (
        <HeaderContainer>
            <HeaderItem width={150}>방문자</HeaderItem>
            <HeaderItem width={150}>방문자 소속</HeaderItem>
            <HeaderItem width={150}>방문 일자</HeaderItem>
            <HeaderItem width={100}>주최자</HeaderItem>
            <HeaderItem width={100}>상태</HeaderItem>
        </HeaderContainer>
    );
};

export default Header;
